<template>
  <div class="procard_wrap">
    <!-- 注释掉分页条
    <div class="procard_btn">
      <div
        class="procard_item"
        v-for="(item, index) in procardList"
        :key="index"
        :class="activeIndex === index ? 'active' : ''"
        @click="changeIndex(index)"
      >
        {{ item.tit }}
      </div>
    </div>
    -->
    <div class="procard_content">
      <div class="content_left">
        <!-- <div class="left_tit">{{ procardTitle }}</div> -->
        <div class="left_icon_wrap" :class="iconWrapClass">
          <div
            class="icon_item"
            v-for="(item, index) in procardImgList"
            :key="index"
            ref="iconItem"
          >
            <div class="icon-container">
              <img :src="item.src" class="icon-img" :alt="item.txt" />
            </div>
            <span>{{ item.txt }}</span>
          </div>
        </div>
      </div>
      <!-- 注释掉右侧图片
      <div class="content_right">
        <img :src="procardImg" alt="" />
        <router-link class="left_btn hidden-sm-and-up" to="/demo"
          >立即体验</router-link
        >
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      procardTitle: '',
      procardImg: require('../../assets/img/government-right-1.png'),
      procardImgList: []
    }
  },
  props: {
    procardList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    // 根据传入的 procardList 第一项的标题来判断当前页面类型
    if (this.procardList && this.procardList.length > 0) {
      const pageTitle = this.procardList[0].tit
      if (pageTitle === '上下游协同管理') {
        this.procardTitle = ''
        this.procardImg = require('../../assets/img/government-right-1.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/licaidingdan.png'),
            txt: '上下游协同快速下单',
          },
          {
            src: require('../../assets/img/icons/xinxi.png'),
            txt: '首营信息在线交互',
          },
          {
            src: require('../../assets/img/icons/fengxian.png'),
            txt: '合作伙伴风险识别',
          },
          {
            src: require('../../assets/img/icons/guanli.png'),
            txt: '促销/返利管理',
          },
          {
            src: require('../../assets/img/icons/zidongguanli.png'),
            txt: '经营范围自动识别',
          },
          {
            src: require('../../assets/img/icons/anquan.png'),
            txt: '防串货管理',
          },
        ]
      } else if (pageTitle === '经销商授权管理') {
        this.procardTitle = ''
        this.procardImg = require('../../assets/img/government-right-2.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/xianshangshouquan.png'),
            txt: '线上授权',
          },
          {
            src: require('../../assets/img/icons/piliangchuli.png'),
            txt: '批量处理',
          },
          {
            src: require('../../assets/img/icons/ico_wupinguanli_wupinyouxiaoqiyujing.png'),
            txt: '效期预警',
          },
          {
            src: require('../../assets/img/icons/xinxi.png'),
            txt: '授权模板',
          },
        ]
      } else if (pageTitle === '经销商经营管理系统') {
        this.procardTitle = ''
        this.procardImg = require('../../assets/img/government-right-3.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/GSP.png'),
            txt: 'GSP合规',
          },
          {
            src: require('../../assets/img/icons/churuku.png'),
            txt: '高效出入库',
          },
          {
            src: require('../../assets/img/icons/kuwei.png'),
            txt: '库位管理',
          },
          {
            src: require('../../assets/img/icons/pandian.png'),
            txt: '智慧盘点',
          },
          {
            src: require('../../assets/img/icons/zhinengbuhuo.png'),
            txt: '智能补货',
          },
          {
            src: require('../../assets/img/icons/shangpinzhuisu.png'),
            txt: '商品追溯',
          },
          {
            src: require('../../assets/img/icons/anquan.png'),
            txt: '迎检管理',
          },
          {
            src: require('../../assets/img/icons/ico_caiwuguanli_yuanneishengdanchaxun.png'),
            txt: '业财一体',
          },
        ]
      } else if (pageTitle === '高值耗材手术跟台管理') {
        this.procardTitle = '打造高值耗材手术跟台全流程管理'
        this.procardImg = require('../../assets/img/government-right-4.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/peitaofuwu.png'),
            txt: '预配套管理',
          },
          {
            src: require('../../assets/img/icons/shoushudingdan.png'),
            txt: '手术订单',
          },
          {
            src: require('../../assets/img/icons/huoche.png'),
            txt: '双向物流',
          },
          {
            src: require('../../assets/img/icons/zhihuishoushushi.png'),
            txt: '手术工具管理',
          },
          {
            src: require('../../assets/img/icons/shuzhongjiankong.png'),
            txt: '拍照手术报台',
          },
          {
            src: require('../../assets/img/icons/xiaochengxu.png'),
            txt: '小程序快速下单',
          },
        ]
      } else if (pageTitle === '医疗器械经营质量管理系统') {
        this.procardTitle = ''
        this.procardImg = require('../../assets/img/government-right-1.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/GSP.png'),
            txt: 'GSP合规',
          },
          {
            src: require('../../assets/img/icons/anquan.png'),
            txt: '迎检管理',
          },
          {
            src: require('../../assets/img/icons/UDIzhuisu.png'),
            txt: 'UDI全程追溯',
          },
        ]
        this.$nextTick(() => {
          const iconWrap = document.querySelector('.left_icon_wrap')
          if (iconWrap) {
            iconWrap.classList.add('quality-management')
          }
        })
      } else if (pageTitle === 'AI智能运营管理') {
        this.procardTitle = ''
        this.procardImg = require('../../assets/img/government-right-1.png')
        this.procardImgList = [
          {
            src: require('../../assets/img/icons/zhuyuanshoushu.png'),
            txt: '智能手术模板',
          },
          {
            src: require('../../assets/img/icons/zhinengbuhuo.png'),
            txt: '智能补货',
          },
          {
            src: require('../../assets/img/icons/zhinengcangku.png'),
            txt: '智能仓库',
          },
          {
            src: require('../../assets/img/icons/aizhinengzhushou.png'),
            txt: 'AI智能助手',
          },
        ]
      }
    }
  },
  mounted() {
    // 移除不必要的宽度设置
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case 0:
          this.procardTitle = ''
          this.procardImg = require('../../assets/img/government-right-1.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/licaidingdan.png'),
              txt: '上下游协同快速下单',
            },
            {
              src: require('../../assets/img/icons/xinxi.png'),
              txt: '首营信息在线交互',
            },
            {
              src: require('../../assets/img/icons/fengxian.png'),
              txt: '合作伙伴风险识别',
            },
            {
              src: require('../../assets/img/icons/guanli.png'),
              txt: '促销/返利管理',
            },
            {
              src: require('../../assets/img/icons/zidongguanli.png'),
              txt: '经营范围自动识别',
            },
            {
              src: require('../../assets/img/icons/anquan.png'),
              txt: '防串货管理',
            },
          ]
          break
        case 1:
          this.procardTitle = ''
          this.procardImg = require('../../assets/img/government-right-2.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/xianshangshouquan.png'),
              txt: '线上授权',
            },
            {
              src: require('../../assets/img/icons/piliangchuli.png'),
              txt: '批量处理',
            },
            {
              src: require('../../assets/img/icons/ico_wupinguanli_wupinyouxiaoqiyujing.png'),
              txt: '效期预警',
            },
            {
              src: require('../../assets/img/icons/xinxi.png'),
              txt: '授权模板',
            },
          ]
          break
        case 2:
          this.procardTitle = ''
          this.procardImg = require('../../assets/img/government-right-3.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/GSP.png'),
              txt: 'GSP合规',
            },
            {
              src: require('../../assets/img/icons/churuku.png'),
              txt: '高效出入库',
            },
            {
              src: require('../../assets/img/icons/kuwei.png'),
              txt: '库位管理',
            },
            {
              src: require('../../assets/img/icons/pandian.png'),
              txt: '智慧盘点',
            },
            {
              src: require('../../assets/img/icons/zhinengbuhuo.png'),
              txt: '智能补货',
            },
            {
              src: require('../../assets/img/icons/shangpinzhuisu.png'),
              txt: '商品追溯',
            },
            {
              src: require('../../assets/img/icons/anquan.png'),
              txt: '迎检管理',
            },
            {
              src: require('../../assets/img/icons/ico_caiwuguanli_yuanneishengdanchaxun.png'),
              txt: '业财一体',
            },
          ]
          break
        case 3:
          this.procardTitle = '打造高值耗材手术跟台全流程管理'
          this.procardImg = require('../../assets/img/government-right-4.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/peitaofuwu.png'),
              txt: '预配套管理',
            },
            {
              src: require('../../assets/img/icons/shoushudingdan.png'),
              txt: '手术订单',
            },
            {
              src: require('../../assets/img/icons/huoche.png'),
              txt: '双向物流',
            },
            {
              src: require('../../assets/img/icons/zhihuishoushushi.png'),
              txt: '手术工具管理',
            },
            {
              src: require('../../assets/img/icons/shuzhongjiankong.png'),
              txt: '拍照手术报台',
            },
            {
              src: require('../../assets/img/icons/xiaochengxu.png'),
              txt: '小程序快速下单',
            },
          ]
          break
        case 4:
          this.procardTitle = '确保合规运营，实现全程可追溯'
          this.procardImg = require('../../assets/img/government-right-5.png')
          this.procardImgList = [
            {
              src: 'icon-gsp2',
              txt: 'GSP合规',
            },
            {
              src: 'icon-yingjian2',
              txt: '迎检管理',
            },
            {
              src: 'icon-udi',
              txt: 'UDI全程追溯',
            },
          ]
          break
        case 5:
          this.procardTitle = ''
          this.procardImg = require('../../assets/img/government-right-1.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/GSP.png'),
              txt: 'GSP合规',
            },
            {
              src: require('../../assets/img/icons/anquan.png'),
              txt: '迎检管理',
            },
            {
              src: require('../../assets/img/icons/UDIzhuisu.png'),
              txt: 'UDI全程追溯',
            },
          ]
          this.$nextTick(() => {
            const iconWrap = document.querySelector('.left_icon_wrap')
            if (iconWrap) {
              iconWrap.classList.remove('quality-management')
              iconWrap.classList.add('quality-management')
            }
          })
          break
        case 6:
          this.procardTitle = ''
          this.procardImg = require('../../assets/img/government-right-1.png')
          this.procardImgList = [
            {
              src: require('../../assets/img/icons/zhuyuanshoushu.png'),
              txt: '智能手术模板',
            },
            {
              src: require('../../assets/img/icons/zhinengbuhuo.png'),
              txt: '智能补货',
            },
            {
              src: require('../../assets/img/icons/zhinengcangku.png'),
              txt: '智能仓库',
            },
            {
              src: require('../../assets/img/icons/aizhinengzhushou.png'),
              txt: 'AI智能助手',
            },
          ]
          break
      }
    },
  },
  computed: {
    iconWrapClass() {
      return `icons-${this.procardImgList.length}`
    }
  }
}
</script>

<style lang="scss" scoped>
.procard_wrap {
  width: 100%;
  background: #fff;
  border-radius: 16PX;
  overflow: hidden;

  .procard_content {
    width: 1200PX;
    margin: 0 auto;
    padding: 30PX;

    @media screen and (max-width: 768px) {
      width: 100%;
      padding: 20PX 15PX;
    }

    .content_left {
      width: 100%;

      .left_tit {
        font-size: 28PX;
        color: #333;
        font-weight: 600;
        margin-bottom: 40PX;
        text-align: center;
        background: linear-gradient(90deg, #2091d3, #52c41a);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        @media screen and (max-width: 768px) {
          font-size: 24PX;
          margin-bottom: 30PX;
        }
      }

      .left_icon_wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 40PX 30PX;
        padding: 20PX;
        max-width: 1200PX;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          grid-template-columns: 1fr !important;
          gap: 16PX;
          padding: 10PX;
        }

        &.icons-1, &.icons-2, &.icons-4, &.icons-5, &.icons-6, &.icons-7, &.icons-8 {
          grid-template-columns: repeat(4, 1fr);
        }
        &.icons-3 {
          grid-template-columns: repeat(3, 1fr);
        }

        .icon_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 24PX;
          border-radius: 12PX;
          background: rgba(32, 145, 211, 0.03);
          transition: all 0.3s ease;
          cursor: pointer;
          min-width: 240PX;

          @media screen and (max-width: 768px) {
            min-width: auto;
            padding: 16PX;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: rgba(32, 145, 211, 0.02);
          }

          .icon-container {
            width: 88PX;
            height: 88PX;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20PX;
            border-radius: 50%;
            background: rgba(32, 145, 211, 0.08);
            transition: all 0.3s ease;

            @media screen and (max-width: 768px) {
              width: 60PX;
              height: 60PX;
              margin-bottom: 16PX;
              margin-right: 0;
            }

            .icon-img {
              width: 48PX;
              height: 48PX;
              transition: all 0.3s ease;
              filter: brightness(0) saturate(100%) invert(45%) sepia(98%) saturate(1720%) hue-rotate(194deg) brightness(97%) contrast(91%);
              opacity: 0.9;

              @media screen and (max-width: 768px) {
                width: 36PX;
                height: 36PX;
              }
            }
          }

          span {
            font-size: 16PX;
            color: #333;
            line-height: 1.5;
            transition: all 0.3s ease;
            font-weight: 500;
            padding: 0 8PX;

            @media screen and (max-width: 768px) {
              text-align: center;
              padding: 0 8PX;
              flex: none;
            }
          }

          &:hover {
            background: #fff;
            transform: translateY(-5PX);
            box-shadow: 0 12PX 24PX rgba(32, 145, 211, 0.12);

            @media screen and (max-width: 768px) {
              transform: none;
              box-shadow: none;
              background: rgba(32, 145, 211, 0.05);
            }

            .icon-container {
              transform: scale(1.05);
              background: rgba(32, 145, 211, 0.12);

              @media screen and (max-width: 768px) {
                transform: none;
              }
            }

            span {
              color: #2091d3;
              font-weight: 600;
            }
          }
        }
      }

      .left_btn {
        display: block;
        width: 200PX;
        height: 48PX;
        line-height: 48PX;
        text-align: center;
        margin: 40PX auto 0;
        background: linear-gradient(90deg, #2091d3, #52c41a);
        border-radius: 24PX;
        color: #fff;
        font-size: 16PX;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2PX);
          box-shadow: 0 8PX 15PX rgba(32, 145, 211, 0.2);
        }
      }
    }
  }
}
</style>
